import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';


@Component({
  selector: 'app-livepoint-report',
  templateUrl: './livepoint-report.component.html',
  styleUrls: ['./livepoint-report.component.scss']
})
export class LivepointReportComponent implements OnInit {
  date ;
  selectedDate : any = ""
   constructor(
     private apiService : ApiService,
     private apiConfig : ApiConfiguration,
     private exportExcelService : ExportExcelService
   ) { 
     let currentDate = new Date()
     this.date = moment(currentDate).format("YYYY-MM-DD")
     this.selectedDate = this.date
   }
 
   ngOnInit() {
   }
 
   
 
   filterListOfRecords(){
     this.apiService.get(this.apiConfig.liveReport + `?program_id=1&date=${this.date}&report_id=4`).subscribe((res : any)=>{
       console.log(res);
       this.downloadExcel(res.data.report_data)
     })
   }
 
   downloadExcel(data){
     let sheetName = "sheet1";
     let filename = "Live_report_";
     let excelData = data;
     let excelArray = [
      { header: 'User ID',  key: 'id' },
      { header: 'CSM Mobile Number',key: 'username'},
      { header: 'CSM Name',key: 'user_detail_name'},
      { header: 'Enrolled Date', key: 'enrolled_date' },
      { header: 'Currently Mapped Outlet Code',key: 'ro_code'},
      { header: 'Outlet Name', key: 'ro_name'},
      { header: 'Points Earned', key: 'earned_points'},
      { header: 'Points Redeemed', key: 'redeemd_points'},
      { header: 'Points Balance (Live)',    key: 'live_points'},
     ]
     this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
   }
 
 }
 